<template>
  <div>
    <el-card>
      <el-row :gutter="30">
        <el-col :span="8">
          <el-button type="primary" @click="dialogFormVisible = true">添加图片</el-button>
          <!--    弹窗    -->
          <el-dialog title="上传图片" :visible.sync="dialogFormVisible">
            <el-radio v-model="radio2" label="轮播" border>轮播</el-radio>
            <el-radio v-model="radio2" label="课程" border>课程</el-radio>
            <el-radio v-model="radio2" label="介绍" border>介绍</el-radio>
<!--            选中:{{radio2}}-->
            <el-divider></el-divider>
            <el-upload
                class="upload-demo"
                drag
                :on-change="uploadFile"
                :before-upload="beforeAvatarUpload"
                :http-request="handlePictureCardPreview"
                action="#"
                multiple>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text"><em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">建议尺寸1792*764/1920*1080像素，且不超过10m</div>
              <img v-if="imageUrl" :src="imageUrl" style="width: 100%;position: relative;top: -70%;height: 200px"/>
            </el-upload>

            <br>
            <el-button type="primary" @click="dialogFormVisible = false,save(radio2)">上传</el-button>
          </el-dialog>
        </el-col>
      </el-row>

      <!-- 列表 -->
      <el-table
          :data="shuffleList"
          border stripe>
        <el-table-column type="index"></el-table-column>
        <el-table-column label="图片" prop="url" width="400px">
          <!-- 图片的显示 -->
          <template v-slot="scope">
<!--            <img :src="scope.row.url" min-width="70" height="70"/>-->
<!--            <img :src="scope.row.url1" min-width="70" height="70"/>-->
            <img :src="scope.row.url2" min-width="70" height="70"/>
<!--            <img :src="scope.row.url3" min-width="70" height="70"/>-->
          </template>
        </el-table-column>

        <el-table-column label="类型" prop="type" width="100px"></el-table-column>
        <el-table-column label="链接" prop="url"></el-table-column>
        <el-table-column label="操作" width="80px">
          <template v-slot="scope">
            <el-button type="danger" icon="el-icon-delete"
                       @click="delComment(scope.row.id)"></el-button>
          </template>
        </el-table-column>
      </el-table>

    </el-card>
  </div>
</template>

<script>
import {Message, MessageBox} from "element-ui";

export default {
  name: "Shuffle",
  data() {
    return {
      imageUrl:'',
      radio2:'',
      limit:1,
      fileList: [],
      dialogTableVisible: false,
      dialogFormVisible: false,
      dialogImageUrl: '',
      shuffleList: [],
      queryInfo: {
        query: '',
        pagenum: 1, // 当前页数
        pagesize: 5 // 当前每页显示的条数
      },
      total: 0
    }
  },

  created() {
    this.getShuffle()
  },

  methods: {
    uploadFile(item) {
      console.log(item)

      this.dialogImageUrl = item.name;
      this.imageUrl = URL.createObjectURL(item.raw); // 图片上传浏览器回显地址
      const isLt3M = item.raw.size / 1024 / 1024 / 1024 < 30;
      if (!isLt3M) {
        return Message.error("上传图片大小不能超过 30MB!");
        this.imageUr = '';
      }

    },
    beforeAvatarUpload(file) {
      const isLt50M = file.size / 1024 / 1024 < 10;
      if (!isLt50M) {
        this.$message.error('上传视频大小不能超过 10MB!');
        return false;
      }
      return true;
    },
    // 获取轮播图
    async getShuffle() {
      const {data: res} = await this.$http.get("/shuffles")
      console.log(res.data)
      //state.imgUrl = `data: image/jpeg;base64,${btoa(new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), ''))}`
      let array = res.data;

      array.forEach(function (item, index) {
//        decodeURIComponent(str)
         item.url1 = decodeURIComponent(item.url);
//        item.imgUrl = `data: image/jpeg;base64,${btoa(new Uint8Array(item.url).reduce((data, byte) => data + String.fromCharCode(byte), ''))}`;
//        console.log(item); //输出数组的每一个元素
        item.url2 = decodeURI(item.url, "utf-8");

        const bytes = new TextEncoder().encode(item.url);
        item.url3 = new TextDecoder("utf-8").decode(bytes);
      });

      this.shuffleList = res.data

},
    async save(radio2) {
      console.log(radio2)
      if (radio2 == '') {
        return Message.error('请选类型')
      }
      //判断是否有文件再上传
      if (this.fileList.length === 0) {
        return Message.error('请选择单图片上传')
      }
      // 创建一个空的FormData对象:
      const formData = new FormData()
      // 使用FormData.append来添加键/值对到表单里面；
      formData.append('file', this.fileList.file)
      formData.append('type', radio2)

      this.$http.post('/shuffles/addShuffle/add', formData).then(res => {
        if (res.data.code > 0) {
          Message.success('上传成功');
          setTimeout(() => {
            location.reload()
          }, 500);
        } else {
          Message.error('上传失败');
        }
      })
    },
    // 删除
    delComment(id) {
      console.log(id)
      MessageBox.confirm('是否删除这张图片?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delete(`/shuffles/delShuffle/${id}`).then((res) => {
          // if (res.code === 1)
          //   location.reload()
          Message.success("删除成功")
          location.reload()
        })
      })
    },

    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
        var newarr = file.file.name.split('.')

        console.log(newarr[1])
        var newname = file.file.uid + '.' + newarr[1];
        var file1 = new File([file.file], newname);
        console.log(file1,'----------')
        file.file = file1;
      this.fileList = file;
      console.log(this.fileList)
    },
  }
}
</script>

<style scoped>

</style>
